<script setup>
import { computed } from 'vue';
import { cn } from '@/lib/utils';
import { badgeVariants } from '@/components/ui-nova/badge';

// Warianty klas z shadcn-vue (styl reka-nova) — API bez zmian.
const props = defineProps({
    variant: {
        type: String,
        default: 'default',
        validator: (v) => ['default', 'secondary', 'destructive', 'outline', 'ghost', 'link'].includes(v),
    },
    class: String,
});

const classes = computed(() => cn(badgeVariants({ variant: props.variant }), props.class));
</script>

<template>
    <span data-slot="badge" :class="classes"><slot /></span>
</template>
